var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1202_10757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7867 22.3013C24.7867 22.2717 24.804 22.2505 24.804 22.2195V17.5032C24.804 16.4731 23.9474 15.6389 22.8944 15.6389H22.2026V2.31982C22.2026 -0.0869662 21.359 0.000399795 21.359 0.000399795C20.8953 0.000399795 20.5154 0.368182 20.5154 0.823331V5.17754C20.1904 4.13196 19.5708 3.00466 18.8529 3.00466H7.14567C6.42633 3.00466 5.80667 4.13337 5.48022 5.17894V0.82333C5.48022 0.368182 5.10322 0.000399123 4.63667 0.000399123C4.63667 0.000399123 3.79456 0.000399123 3.79456 2.31982V15.6403H3.107C2.05111 15.6403 1.19456 16.4745 1.19456 17.5046V22.2209C1.19456 22.2505 1.209 22.2731 1.21044 22.3027C0.52 22.4816 0 23.0692 0 23.7992C0 24.6728 0.723667 25.3788 1.61922 25.3788H24.3793C25.2749 25.3788 26 24.6728 26 23.7992C26 23.0692 25.48 22.4816 24.7867 22.3013V22.3013Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9357 20.6103C17.9357 21.8771 16.8827 22.9071 15.5784 22.9071H10.4202C9.12168 22.9071 8.0658 21.8785 8.0658 20.6103V15.4965C8.0658 14.2283 9.12024 13.1982 10.4202 13.1982H15.5784C16.8812 13.1982 17.9357 14.2283 17.9357 15.4965V20.6103V20.6103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.97034,
    cy: 20.3506,
    rx: 1.58167,
    ry: 1.543,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.0297,
    cy: 20.3506,
    rx: 1.58167,
    ry: 1.543,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2646 10.9779C19.2646 11.4514 18.8717 11.8346 18.3878 11.8346H7.6137C7.12836 11.8346 6.73547 11.4514 6.73547 10.9779V8.50909C6.73547 8.03704 7.12836 7.65234 7.6137 7.65234H18.3864C18.8702 7.65234 19.2631 8.03563 19.2631 8.50909V10.9779H19.2646Z",
    fill: "#44A6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7266 16.9679L12.8396 20.7768C12.7284 20.8867 12.597 20.974 12.4525 21.0304C12.3037 21.091 12.1506 21.1206 11.9932 21.1206C11.8386 21.1206 11.6797 21.091 11.5367 21.0304C11.3894 20.974 11.258 20.8867 11.1467 20.7768L9.30797 19.0703C9.08841 18.8505 8.9613 18.5503 8.9613 18.2446C8.9613 17.9345 9.08842 17.6372 9.30797 17.4188C9.41775 17.3061 9.54775 17.2159 9.69508 17.1581C9.84386 17.0975 9.99697 17.0693 10.1544 17.0693C10.3119 17.0693 10.4679 17.0989 10.6137 17.1581C10.7611 17.2159 10.8896 17.3047 11.0009 17.4188L11.9036 18.2967L14.9399 15.3333C15.0525 15.222 15.1854 15.1332 15.327 15.0726C15.4772 15.012 15.6346 14.9824 15.7892 14.9824C15.9466 14.9824 16.1055 15.012 16.2485 15.0726C16.3959 15.1332 16.5244 15.2192 16.6356 15.3333C16.757 15.4305 16.8523 15.5517 16.9231 15.6912C16.9939 15.8307 17.03 15.9787 17.0415 16.1309C17.0502 16.2845 17.0242 16.4395 16.9736 16.5804C16.9187 16.7255 16.8335 16.858 16.7266 16.9679V16.9679Z",
    fill: "#0270B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_10757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 25.3788,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.4f4055f978f1046b80bb1fdc187e7449.svg";
export { ForwardRef as ReactComponent };